import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import { useParams, withRouter } from 'react-router';
import MeasurementUnitEditService from '../service/MeasurementUnitEditService';

const config = data => {
	return {
		key: 'measurementUnitEditForm',
		topic: 'measurementUnit',
		service: MeasurementUnitEditService,
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true
				}
			];

			return fields;
		}
	};
};

function MeasurementUnitEditForm() {
	const { id } = useParams();

	const myConfig = config({ id });
	return <EditFormPage config={myConfig} />;
}

export default withRouter(MeasurementUnitEditForm);